<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <!-- formulario -->
    <v-row>
      <v-col
        sm="1"
        lg="2"
        class="hidden-xs-only"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              small
              fixed
              exact
              color="primary"
              v-bind="attrs" 
              v-on="on" 
              @click="regresar"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
          </template>
          <span>Regresar</span>
        </v-tooltip>
      </v-col>
      <v-col 
        cols="12" 
        sm="10" 
        lg="8"
      >
        <v-card 
          outlined 
          elevation="2" 
          :loading="loadingForm"
        >
          <v-card-title class="justify-center">
            <p class="text-h4 font-weight-bold primary--text mt-2">
              Actualizar Competencia
            </p>
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <v-col 
                cols="12" 
                sm="10" 
                lg="8"
              >
                <v-form ref="form" v-model="form">
                  <v-select
                    outlined
                    dense
                    label="Regional*"
                    :items="regionales"
                    item-value="id"
                    item-text="regional"
                    v-model="regional"
                    :rules="regionalReglas"
                  >
                  </v-select>

                  <v-select
                    outlined
                    dense
                    label="Centro de Formación*"
                    :items="centrosFormacion"
                    item-value="id"
                    item-text="centro_formacion"
                    v-model="centroFormacion"
                    :rules="centroFormacionReglas"
                  >
                  </v-select>

                  <v-dialog
                    ref="fechaInicio"
                    v-model="modalFechaInicio"
                    :return-value.sync="fechaInicio"
                    persistent
                    width="300px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        prepend-inner-icon="mdi-calendar"
                        label="Fecha Inicio*"
                        readonly
                        v-model="fechaInicio"
                        :rules="fechaInicioReglas"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>

                    <v-date-picker 
                      scrollable 
                      color="primary"
                      v-model="fechaInicio"
                    >
                      <v-spacer></v-spacer>
                      <v-btn 
                        text 
                        color="error" 
                        @click="modalFechaInicio = false"
                      >
                        Cancelar
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="validarFecha($refs.fechaInicio.save(fechaInicio))"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>

                  <v-dialog
                    ref="fechaFin"
                    v-model="modalFechaFin"
                    :return-value.sync="fechaFin"
                    persistent
                    width="300px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        prepend-inner-icon="mdi-calendar"
                        label="Fecha Fin*"
                        readonly
                        v-model="fechaFin"
                        :rules="fechaFinReglas"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>

                    <v-date-picker 
                      scrollable 
                      color="primary"
                      v-model="fechaFin"
                    >
                      <v-spacer></v-spacer>
                      <v-btn 
                        text 
                        color="error" 
                        @click="modalFechaFin = false"
                      >
                        Cancelar
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="validarFecha($refs.fechaFin.save(fechaFin))"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>

                  <v-text-field
                    outlined
                    dense
                    type="text"
                    label="Competencia*"
                    maxlength="100"
                    counter
                    v-model.trim="competencia"
                    :rules="competenciaReglas"
                  >
                  </v-text-field>

                  <v-textarea
                    outlined
                    rows="4"
                    label="Descripción"
                    v-model.trim="descripcion"
                  >
                  </v-textarea>

                  <v-text-field
                    outlined
                    dense
                    type="text"
                    label="Lugar"
                    maxlength="50"
                    counter
                    v-model.trim="lugar"
                    :rules="lugarReglas"
                  >
                  </v-text-field>

                  <v-text-field
                    outlined
                    dense
                    type="text"
                    label="Dirección*"
                    maxlength="50"
                    counter
                    v-model.trim="direccion"
                    :rules="direccionReglas"
                  >
                  </v-text-field>

                  <v-btn
                    large
                    block
                    exact
                    elevation="2"
                    color="primary"
                    class="mt-2 mb-6"
                    @click="actualizar"
                  >
                    Actualizar
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Alert from '../../../components/admin/Alert.vue'

export default {
  data: () => ({
    alert: false,
    alertType: '',
    alertTitle: '',
    alertMessage: '',

    form: true,
    loadingForm: false,

    regional: '',
    regionalReglas: [
      v => !!v || "Seleccione una regional"
    ],

    centroFormacion: '',
    centroFormacionReglas: [
      v => !!v || "Seleccione un centro de formación"
    ],

    fechaInicio: null,
    fechaInicioReglas: [
      v => !!v || "Seleccione una fecha inicio"
    ],
    modalFechaInicio: false,

    fechaFin: null,
    fechaFinReglas: [
      v => !!v || "Seleccione una fecha fin"
    ],
    modalFechaFin: false,

    competencia: '',
    competenciaReglas: [
      v => !!v || "Escriba una competencia"
    ],
    
    descripcion: '',

    lugar: '',
    lugarReglas: [
      v => !!v || "Escriba un lugar"
    ],

    direccion: '',
    direccionReglas: [
      v => !!v || "Escriba una dirección"
    ]
  }),

  mounted() {
    this.$store.dispatch("crearRegionales");
    this.$store.dispatch("crearCentrosFormacion");
    this.$store.dispatch("obtenerCompetenciaCampesenaId", this.$route.params.idCompetencia)
    setTimeout(() => {
      const data = this.competenciaActualizar
    
      this.regional         = data.regional_id
      this.centroFormacion  = data.centro_formacion_id
      this.fechaInicio      = data.fecha_inicio;
      this.fechaFin         = data.fecha_fin;
      this.competencia      = data.competencia.toLowerCase();
      this.descripcion      = data.descripcion;
      this.lugar            = data.lugar.toLowerCase();
      this.direccion        = data.direccion; 
    }, 1000);
  },

  computed: {
    regionales() {
      return this.$store.getters.obtenerRegionales;
    },

    centrosFormacion() {
      return this.$store.getters.obtenerCentrosFormacion(this.regional);
    },

    competenciaActualizar(){
      return this.$store.getters.obtenerCompetenciaCampesena
    }
  },

  components: {
    Alert 
  },

  methods: {
    actualizar() {
      if (this.$refs.form.validate()) {
        this.loadingForm = true;

        const competencia = {
          id:                   this.$route.params.idCompetencia,
          centro_formacion_id:  this.centroFormacion,
          fecha_inicio:         this.fechaInicio,
          fecha_fin:            this.fechaFin,
          competencia:          this.competencia,
          descripcion:          this.descripcion,
          lugar:                this.lugar,
          direccion:            this.direccion
        };

        this.$store.dispatch("actualizarCompetenciaCampesena", competencia)
        .then((response) => {
          if (response.status == "success") {
            this.loadingForm  = false;
            let message = response.message.split(',')
            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;

            setTimeout(() => {
              this.alert = false
              this.$router.replace({ name: 'campesena-competencia-gestionar' })
            }, 2000)
          }
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";
            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }
            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => {});
      }
    },

    validarFecha() {
      if (this.modalFechaInicio) {
        this.modalFechaInicio = false
      }

      if (this.modalFechaFin) {
        this.modalFechaFin = false
      }
      
      if ((this.fechaInicio != null) && (this.fechaFin != null)) {
        const fecha1 = new Date(this.fechaInicio)
        const fecha2 = new Date(this.fechaFin)
        if (fecha1 >= fecha2) {
          this.fechaFin     = null
          this.fechaInicio  = null
          
          this.alertType    = "error--text";
          this.alertTitle   = "Error";
          this.alertMessage = "Fecha inicio mayor a fecha fin";
          this.alert        = true;

          setTimeout(() =>{
            this.alert = false
          }, 2000)
        }
      }
    },

    regresar() {
      this.$router.back()
    }
  }
};
</script>